var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMidBrandResponsiveLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 501,
    height: 185,
    viewBox: "0 0 501 185",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M434.5 37.9H491.8C496.3 37.9 500 34.2 500 29.7C500 25.2 496.3 21.5 491.8 21.5C490.3 21.5 488.9 21.9 487.7 22.6V22.5C487.7 13.9 480.7 7 472.2 7C465.1 7 459.1 11.8 457.3 18.3C456 17.3 454.3 16.7 452.4 16.7C447.9 16.7 444.2 20.4 444.2 24.9C444.2 25.1 444.2 25.4 444.2 25.6C443.7 25.4 443.1 25.3 442.5 25.3C440 25.3 438 27.2 437.8 29.6C436.9 28.9 435.9 28.5 434.7 28.5C432.1 28.5 430 30.6 430 33.2C430 35.8 432 37.9 434.5 37.9Z",
    fill: "#A98E91",
    stroke: "white",
    strokeWidth: 0.654,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M272 130.2C272 127 269.4 124.4 266.2 124.4C264.8 124.4 263.5 124.9 262.5 125.8C262.2 122.9 259.8 120.6 256.7 120.6C256 120.6 255.3 120.7 254.6 121C254.6 120.7 254.6 120.4 254.6 120.1C254.6 114.5 250.1 110 244.5 110C242.2 110 240.1 110.8 238.4 112C236.2 103.9 228.8 98 220.1 98C209.6 98 201.1 106.5 201.1 117V117.1C199.6 116.2 197.9 115.7 196.1 115.7C190.5 115.7 186 120.2 186 125.8C186 131.4 190.5 135.9 196.1 135.9C196.1 135.9 196.1 135.9 196.2 135.9H266.4C269.5 135.9 272 133.3 272 130.2Z",
    fill: "#754C4E",
    stroke: "white",
    strokeWidth: 0.674,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M136.3 155.5C136.3 151.4 132.9 148.1 128.9 148.1H128.8C129 147.5 129.1 146.8 129.1 146.1C129.1 142 125.7 138.7 121.7 138.7C119.8 138.7 118 139.4 116.7 140.6C114.2 137.2 110.1 135 105.5 135C101 135 97 137.2 94.4 140.5C91.9 137.2 87.8 135 83.3 135C75.6 135 69.3 141.3 69.3 149C69.3 156.7 75.6 163 83.3 163H105.5H107.8H130C133.5 162.4 136.3 159.3 136.3 155.5Z",
    fill: "#F1E8E6",
    stroke: "white",
    strokeWidth: 0.448,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M249.9 42.1C249.9 38 246.6 34.7 242.5 34.7C240.7 34.7 239 35.4 237.7 36.4C237.4 32.7 234.2 29.8 230.3 29.8C229.4 29.8 228.5 30 227.6 30.3C227.6 30 227.7 29.6 227.7 29.1C227.7 22 221.9 16.2 214.8 16.2C211.9 16.2 209.2 17.2 207.1 18.8C204.3 8.6 194.9 1 183.7 1C170.3 1 159.4 11.9 159.4 25.3C159.4 25.4 159.4 25.4 159.4 25.5C157.5 24.4 155.3 23.8 152.9 23.8C145.8 23.8 140 29.6 140 36.7C140 43.8 145.8 49.6 152.9 49.6H153H242.8C246.8 49.4 249.9 46.1 249.9 42.1Z",
    fill: "#F1E8E6",
    stroke: "white",
    strokeWidth: 0.7765,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M97.5 168.4C97.5 159.5 90.2999 152.3 81.3999 152.3C81.2999 152.3 81.2999 152.3 81.2 152.3C81.6 150.9 81.8 149.5 81.8 148C81.8 139.1 74.6 131.9 65.7 131.9C61.6 131.9 57.8 133.6 54.9 136.2C49.3 128.9 40.7 124.1 30.7999 124.1C14.0999 124.1 0.699951 137.6 0.699951 154.2C0.699951 170.9 14.1999 184.3 30.7999 184.3H83.5L83.3999 184.2C91.3999 183.3 97.5 176.5 97.5 168.4Z",
    fill: "white",
    stroke: "#F1E8E6",
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMidBrandResponsiveLeft);
export default __webpack_public_path__ + "static/media/mid_brand_responsive_left.bac9e9a8c5fd094dc94e6a94c9ea4bb9.svg";
export { ForwardRef as ReactComponent };